import React from "react";
import "../../../styles/HouseRules.scss"

interface Rule {
  id: string;
  rule: string;
}

interface Props {
  rules: Rule[];
}

const HouseRules: React.FC<Props> = ({ rules }) => (
  <div className="house-rules">
    <ul>
      {rules.map((rule) => (
        <li key={rule.id}>• {rule.rule}</li>
      ))}
    </ul>
  </div>
);

export default HouseRules;
